import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchUpdateAlexaSkills } from './dispatch-optimistic-patch';
import { UpdateAlexaSkillsQueryArg } from '../types/query-arg';

export const handleResultUpdateAlexaSkills: QueryHandler<
  UpdateAlexaSkillsQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchUpdateAlexaSkills(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
